<template lang="pug">
  .spinner
    spinner(:size="24", line-fg-color="#777")
    .label {{label}}
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
// tslint:disable-next-line
const Spinner = require('vue-simple-spinner')

@Component({
  components: { Spinner },
})
export default class extends Vue {
  @Prop({ required: true })
  label!: string
}
</script>


<style lang="scss" scoped>
.spinner {
  display: flex;
  align-items: center;
}

.label {
  margin: 0 1em;
  color: white;
}
</style>